angular.module('filters').filter('limitString', ["$filter", function($filter) {
  return function(input, limit) {
    var result;
    if (!(input && input.length)) {
      return;
    }
    result = $filter('limitTo')(input, limit);
    if (input.length > limit) {
      result = result + '...';
    }
    return result;
  };
}]);
